import type { ChannelId, ClientRequestId } from '../core/types';
import { parseApiResponse } from './http';
import { parseEchoSendResponse, type EchoWireMessage } from './wire';

export interface EchoSendTransport {
  post(path: string, json?: unknown, extra?: RequestInit): Promise<Response>;
}

export async function sendEchoMessage(
  channelId: ChannelId,
  post: EchoSendTransport['post'],
  clientRequestId: ClientRequestId,
  body: string
): Promise<EchoWireMessage> {
  const response = await post(echoMessagesPath(channelId), {
    message: {
      text: body,
      optimistic_sort_order: clientRequestId
    }
  });
  const data = await parseApiResponse(response, parseEchoSendResponse);
  return data.message;
}

function echoMessagesPath(channelId: ChannelId): string {
  return `/channels/${encodeURIComponent(channelId)}/messages`;
}
